import { defineStore } from 'pinia';
import { ref } from 'vue';
import { readStorage, writeStorage } from '../utils/storage';
const KEY = 'compass.theme';
export type Theme = 'light' | 'dark' | 'blue';
export const useThemeStore = defineStore('theme', () => {
  const current = ref<Theme>('blue');
  let listening = false;
  const preferred = (): Theme => 'blue';
  const isTheme = (value: string | null): value is Theme => value === 'light' || value === 'dark' || value === 'blue';
  function apply(theme: Theme) {
    current.value = theme; document.documentElement.dataset.theme = theme; document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
  }
  function init() {
    const stored = readStorage('localStorage', KEY);
    apply(isTheme(stored) ? stored : preferred());
    if (!listening) {
      window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => { if (!readStorage('localStorage', KEY)) apply(preferred()); });
      listening = true;
    }
  }
  function setTheme(theme: Theme) { apply(theme); writeStorage('localStorage', KEY, theme); }
  return { current, init, setTheme };
});
